import { GET_CIERRE_DIARIO, MODIFY_DATOS_CIERRE_DIARIO, } from '../constants/action_types';

const initialState = { datos: [], isLoading: false };

export default function (state = initialState, action) {


    switch (action.type) {

        case GET_CIERRE_DIARIO:

            return {
                datos: [],
                isLoading: true
            };


        case GET_CIERRE_DIARIO + "_SUCCESS":

            const datosCierreDiario = action.payload.data.slice();

            // const arcade = datosCierreDiario.find(c => c.iKind === 3);
            // if (arcade) {

            //     let importe = 0.0;

            //     datosCierreDiario.filter(i => i.iKind === 6).forEach(arqueo => {

            //         if (arqueo.articuloId === 0) {
            //             importe += arqueo.importe;
            //         }
            //         else {
            //             importe -= arqueo.importe;
            //         }

            //     });


            //     const cobrosArcade = { ...arcade, importe: importe, concepto: 'Cobros/Pagos', isMovCaja: 1, producto: 'Cobros Arcade', iKind: 100 }; // iKind 100 (creado al cliente, no viene de la base de datos o el servidor)
            //     datosCierreDiario.push(cobrosArcade);
            // }
            return {
                datos: datosCierreDiario,
                isLoading: false
            };

        case MODIFY_DATOS_CIERRE_DIARIO:

            const newDatos = state.datos.filter(i => i.iKind !== 100).map((item) => {
                if (item.articuloId !== action.payload.articuloId) return item;
                else return action.payload;
            });

            const cobrosArcade = state.datos.find(c => c.iKind === 100);
            if (cobrosArcade) {

                let importe = 0.0;

                newDatos.filter(i => i.iKind === 6).forEach(arqueo => {

                    if (arqueo.articuloId === 0) {
                        importe += arqueo.importe;
                    }
                    else {
                        importe -= arqueo.importe;
                    }

                });

                newDatos.push({ ...cobrosArcade, importe: importe });
            }

            return {
                datos: newDatos,
                isLoading: false
            };


        default:

            return state;
    }
}